export default "/imgs/email-verify.png"